import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib/cn';

interface EntitlementStatusBadgeProps {
  status: string | null;
  className?: string;
}

export function EntitlementStatusBadge({ status, className }: EntitlementStatusBadgeProps) {
  const { t } = useTranslation();

  if (!status) {
    return (
      <span className={cn('text-xs text-muted-foreground italic', className)}>
        {t('trials.entitlement.unavailable')}
      </span>
    );
  }

  const key = `trials.entitlement.${status}` as const;
  const label = t(key, { defaultValue: status });

  const tone =
    status === 'active'
      ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400'
      : status === 'suspended'
        ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400'
        : 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300';

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        tone,
        className,
      )}
    >
      {label}
    </span>
  );
}
